<template>
  <div class="gsxw_con">
    <div class="Company_box">
      <p class="Company_text">公司公告</p>
      <div class="arrow-right">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">你现在所在的位置</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>资讯中心</el-breadcrumb-item>
          <el-breadcrumb-item>公司公告</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <!-- <div class="user_box" v-for="(item,index) in  list" :key="index">
      <p class="user_text">{{item.title}}</p>
      <div class="date_box">
        <p class="item_text">日期:{{item.addtime}}</p>
      </div>
        <div v-html="item.content" class="content_text"></div>
    </div> -->
    <div class="xiangqing">
      <div style="line-height: 2" v-for="(item, index) in list" :key="index">
        <div class="lszt" @click="xqy(item.id, item.bid, 5, listQuery.pageNums)">
          <p>
            {{ item.title }}
          </p>
          <p>{{ item.addTime }}</p>
        </div>

        <!-- <div class="changwz " style='white-space: pre-wrap;' v-html="item.fu_title"></div> -->
        <!-- <p class="xhx"></p> -->
      </div>

      <el-pagination v-if="this.qw == 1" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="listQuery.pageNums" :page-sizes="[5, 10, 15, 20]" :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
      <el-pagination v-if="this.qw == 2" small @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="listQuery.pageNums" :page-sizes="[5, 10, 15, 20]" :page-size="listQuery.pageSize"
        layout="prev, pager, next" :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
// import pagination from "../../components/haed/pagination";
import qs from "qs";

export default {
  name: "company",
  components: {
    // pagination,
  },
  data() {
    return {
      listQuery: {
        bsId: "",
        pageNums: 1,
        pageSize: 5,
      },
      total: 9,
      list: [],
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      qw: "",
    };
  },
  created() {
    if (this.windowWidth > 1000) {
      this.qw = 1;
    } else if (this.windowWidth < 1000) {
      this.qw = 2;
    }
    if (this.$route.query.page) {
      this.listQuery.pageNums = this.$route.query.page * 1;
    }
  },
  watch: {
    windowHeight(val) {
      let that = this;
      // console.log("实时屏幕高度：",val, that.windowHeight );

      // console.log(val, "实时屏幕高度：");
      // this.qq= val
    },
    windowWidth(val) {
      let that = this;
      console.log("实时屏幕宽度：", val, that.windowWidth);
      // console.log(val, "实时屏幕宽度：");
      if (that.windowWidth > 1000) {
        this.qw = 1;
      } else if (that.windowWidth < 1000) {
        this.qw = 2;
      }
    },
  },
  mounted() {
    this.Companynews();
  },
  methods: {
    getShowLists() {
      this.Companynews();
    },
    xqy(id, bid, name, page) {
      this.$router.push({
        path:
          "/Companynews?id=" + id + "&menu=3" + "&type=22" + "&rr=5"
      });
    },
    handleCurrentChange(val) {
      this.listQuery.pageNums = val;
      this.$axios({
        // method: "post",
        // url: "/index.php/news/newslist",
        method: "get",
        url: "/changhang/index/list?menu=3&type=22&pageSize=5&pageNum=" + val,
        data: qs.stringify({
          // id: 21,
          pageNum: val,
          pageSize: 5,
        }),
      })
        .then((res) => {
          this.list = res.data.rows;
          this.total = res.data.total;
        })
        .catch((res) => {
          console.log("1111111" + res);
        });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    Companynews() {
      var _this = this;
      this.$axios({
        // method: "post",
        // url: "/index.php/news/newslist",
        // data: qs.stringify({
        //   id: 21,
        //   pageNum: _this.listQuery.pageNums,
        //   pageSize: 5,
        // }),
        method: "get",
        url: "/changhang/index/list?menu=3&type=22&pageSize=5&pageNum=1",
      })
        .then((res) => {
          this.list = res.data.rows;
          this.total = res.data.total;
        })
        .catch((res) => { });
    },
  },
};
</script>
<style scoped>
.gsxw_con {
  margin-left: 40px;
}

.el-pagination {
  /* width: 96%; */
  margin-top: 10px;
  margin-bottom: 10px;
}

.changwz {
  font-size: 16px;
}

.el-breadcrumb {
  font-size: 16px !important;
}

.xhx {
  /* background-color: #cccccc;
  width: 100%;
  height: 1px; */
  /* margin: 2% 0; */
}

.Company_box {
  display: flex;
  width: 100%;
  height: 2vw;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-top: 10px;
  border-bottom: 1px solid #dedede;
}

.lszt {
  color: #1592e6;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  font-size: 16px;
  border-bottom: 1px solid #cccccc
}

.Company_text {
  font-weight: bold;
  font-size: 32px;
  color: #0c47a1;
  text-align: center;
  line-height: 2vw;
  /* margin-left: 10px; */
  margin-top: -0.5vw;
}

/* .arrow-right{
  font-size: 1vw;
} */
.item_text {
  width: 100%;
  text-align: center;
  color: #3d3d3d;
}

.content_text {
  width: 100%;
  height: 100%;
  font-size: 20px;
  color: #3d3d3d;
  margin-bottom: 5%;
}

.fenye {
  text-align: center;
}

.user_text {
  margin: 0 auto;
  margin-top: 10px;
  text-align: center;
  font-size: 24px;
}

.user_box {
  width: 50%;
  /* height: 3.5vw; */
  margin: 0 auto;
}

.date_text {
  width: 90%;
  margin-top: 10px;
  margin-left: 10px;
  font-size: 0.9vw;
}

.date_box {
  width: 40%;
  height: 2vw;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  margin-top: 10px;
  font-size: 1vw;
}

.date_img {
  width: 90%;
  height: 30vw;
  margin-left: 10px;
  margin-top: 10px;
}

.date_img img {
  width: 100%;
  height: 100%;
}

.Previous_box {
  width: 90%;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  font-size: 0.9vw;
}

@media screen and (min-width: 320px) and (max-width: 750px) {
  .Company_box {
    display: none;
  }

  .gsxw_con {
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 20px;
  }

  .el-pagination {
    text-align: center;
    display: block;
    font-size: 12px !important;
  }

  /* .user_box {
    width: 100%;
  }
  .user_text {
    font-size: 12px;
  }
  .content_text {
    margin-top: 25px;
    font-size: 12px;
  }
  .date_box {
    width: 50%;
  }
  .el-pagination {
    display: none;
  } */
}
</style>
<style>
.el-pagination {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/haed/gonggao.vue